(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-product-actions]').forEach(actions => {
      if (actions.dataset.actionsReady) return;
      actions.dataset.actionsReady = 'true';
      const report = actions.querySelector('[data-report-dialog]');
      const share = actions.querySelector('[data-share-dialog]');
      const productRoot = actions.closest('.bza');
      const productUrl = new URL(actions.dataset.productUrl, location.origin);
      const productTitle = () => productRoot?.querySelector('[data-title]')?.textContent?.trim() || actions.dataset.productTitle;
      let opener;
      const open = (dialog, trigger) => {
        if (!dialog || typeof dialog.showModal !== 'function') return false;
        opener = trigger;
        if (!dialog.open) dialog.showModal();
        return true;
      };
      actions.querySelectorAll('dialog').forEach(dialog => {
        dialog.querySelectorAll('[data-dialog-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
        dialog.addEventListener('close', () => opener?.focus({preventScroll: true}));
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
      });
      actions.querySelector('[data-report-open]')?.addEventListener('click', event => {
        if (!report || typeof report.showModal !== 'function') return;
        event.preventDefault();
        actions.querySelector('[data-report-title]').textContent = productTitle();
        const name = report.querySelector('[data-report-product]');
        const variation = report.querySelector('[data-report-variation]');
        if (name) name.value = productTitle();
        if (variation) variation.value = productRoot?.querySelector('[data-options] [aria-pressed="true"]')?.textContent?.trim() || '';
        open(report, event.currentTarget);
      });
      report?.querySelectorAll('[data-report-reason]').forEach(input => input.addEventListener('change', () => {
        if (input.dataset.reportReason === 'other') {
          const details = report.querySelector('.bz-report-details');
          if (details) details.open = true;
        }
      }));
      actions.querySelector('[data-product-share]')?.addEventListener('click', event => open(share, event.currentTarget));
      actions.querySelector('[data-copy-link]')?.addEventListener('click', async () => {
        const status = actions.querySelector('[data-copy-status]');
        try { await navigator.clipboard.writeText(productUrl.href); status.textContent = actions.dataset.copySuccess; }
        catch { const field = actions.querySelector('[data-share-url]'); field?.focus(); field?.select(); status.textContent = actions.dataset.copyFailed; }
      });
      const result = report?.querySelector('[data-support-success], [data-support-errors]');
      if (result && open(report, actions.querySelector('[data-report-open]'))) result.focus();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


